module.exports = __webpack_public_path__ + "static/media/(DH)_MG_5488_-_bijuterias.f11eae07.jpg";